module.exports = __webpack_public_path__ + "static/img/strategicbg001.326ced0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/strategicbg001.png
// module id = mJ2F
// module chunks = 1